<template>
	<div v-if="isVisible" :class="classObject" @click="handleClick($event, item)">
		<div class="icon">
			<div :class="['documentIcon', extensionClass]" />
		</div>
		<div class="documentName">
			<span class="name">{{ item.Name.replace(/\s/g,'&nbsp;') }}</span>
			<span class="description">{{ item.Description }}</span>			
		</div>
		<multi-help v-if="invalidMsg" @click.stop>
			<template #multiHoverHelp>
				<tile-help :tile-error="invalidMsg" />
			</template>
			<template #multiMobile>
				<tile-help :tile-error="invalidMsg" />
			</template>
		</multi-help>
	</div>
</template>

<script>
import { extension } from "../../helpers/file.js";
import { mapState } from "vuex";
import TileHelp from "./TileHelp.vue";
import MultiHelp from "../../components/ui/MultiHelp.vue";

const documentSmall = {
	template: `#documentSmall`,
	components: {
		MultiHelp,
		TileHelp,
	},
	props: {
		item: {
			type: Object, 
			required: true 
		},
	},
	emits: [`selectDocument`],
	computed: {
		...mapState([`acceptedExtensions`, `maxFileSize`]),
		isLawDepotDocument() {
			return !this.item.IsUserUpload;
		},
		isVisible() {
			return !this.invalidDocument;
		},
		canSelect() {
			return (
				// Completed and paid for notary documents show up as user uploads, not law depot documents (IsUserUpload flag is true).
				(!this.isLawDepotDocument && this.isExtensionAccepted && this.maxFileSize > this.size && this.size > 0) ||
				(this.isLawDepotDocument && this.isNotarizable)
			);
		},
		isNotarizable() {
			return (!this.invalidDocument && //Only valid tiles
				!this.isEsignDocument && //Not e-sign documents
				this.hasLicense && //lawdepot license
				!this.isMultiUserDocument); //multi-user question document
		},
		hasLicense() {
			return this.item.TileAccess;
		},
		invalidDocument() {
			return this.item.ProductName == `Online Notary` && 
				this.item.NotarySessionId != null && 
				this.item.NotaryDocumentId == null || // Notarization Tiles
				this.item.CountryCode != null && 
				this.item.CountryCode != `US`; // Only US and uploaded documents
		},
		isEsignDocument() {
			return this.item.EsignatureStatus > 0;
		},
		isMultiUserDocument() {
			return this.item.MultiuserStatus > 0;
		},
		size() {
			return this.item.Blob.Size;
		},
		extension() {
			return extension(this.filename);
		},
		filename() {
			return this.item.Blob.Filename;
		},
		classObject() {
			return [
				this.invalidMsg > 0 ? `invalidDoc`: this.extension?.substring(1),
				this.getDocType(this.item.DocumentType),
				{ selected: this.item.isSelected },
				{ folderTileSmall: this.canSelect },
				{ documentTileSmall: !this.canSelect },
			];
		},
		isExtensionAccepted() {
			return this.acceptedExtensions.has(this.extension);
		},
		extensionClass() {
			if (this.isLawDepotDocument) return null;
			return `icon-${this.extension?.substring(1)} fileUpload`;
		},
		invalidMsg() {
			let tileError = 0;
			if (!this.isExtensionAccepted && !this.isLawDepotDocument) tileError = 1;		
			if (!this.hasLicense && this.item.ProductCode != null) tileError = 2;
			if (this.maxFileSize <= this.size) tileError = 3;
			if (this.isEsignDocument) tileError = 4;
			if (this.size === 0 && !this.isLawDepotDocument) tileError = 5;

			let doc = this.item.ProductCode;
			let invalidDocs = 
				doc === `CINCRP` ||	
				doc === `COHAB`  ||
				doc === `DIVRCE` ||
				doc === `POWILL` ||
				doc === `PRENUP` ||
				doc === `SEPAGR` ||
				doc === `WILL`    ;
			if (invalidDocs) tileError = 6;
			
			return tileError;
		},
	},
	methods: {
		getDocType: function (type) {
			return `documentType${type}`;
		},
		handleClick: function (event, item) {
			if (this.canSelect) {
				this.$emit(`selectDocument`, item);
			}
		},
	},
};

export default documentSmall;
</script>